import { apiGix } from '../api-config';

export default async function (idUser: string, bearer: string, stKey: string) {
  const uri = `v3.15/api/Journey/mobile/getSummaryByUser?tokenKey=${stKey}&cdUser=${idUser}`;
  return apiGix.get(`${uri}`, {
    headers: {
      Authorization: `${bearer}`,
    },
  });
}
